import { BROADCAST_SET_DIRECTOR_REQUEST_MESSAGE } from '../Types';

function setDirectorRequestMessage({ key, value }) {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_DIRECTOR_REQUEST_MESSAGE,
      payload: {
        key,
        value
      }
    };
    dispatch(action);
  };
}

export default setDirectorRequestMessage;
